"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarSizeOptions = exports.BaseAvatar = exports.Avatar = exports.AVATAR_SIZE = exports.AVATAR_COLOR = void 0;
var React = _interopRequireWildcard(require("react"));
var _color = require("../../styles/variables/_color");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _StatusIndicator = require("../StatusIndicator");
var _Text = require("../Text");
var _AvatarModule = _interopRequireDefault(require("./Avatar.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AVATAR_SIZE = exports.AVATAR_SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge'
});
const avatarSizeOptions = exports.avatarSizeOptions = [...Object.keys(AVATAR_SIZE)];
const AVATAR_COLOR = exports.AVATAR_COLOR = Object.freeze({
  red: _color.colorDangerLightest,
  orange: _color.colorWarningLightest,
  green: _color.colorSuccessLightest,
  blue: _color.colorInformationLightest,
  gray: _color.colorGrayLightest,
  indigo: _color.colorNeutralLightest
});
const getAvatarText = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const [firstWord, secondWord] = text.split(' ');
  const firstChar = firstWord ? firstWord[0].toUpperCase() : '';
  const secondChar = secondWord ? secondWord[0].toUpperCase() : '';
  return firstChar + secondChar;
};
const AvatarTextDecorator = _ref => {
  let {
    avatarText,
    size,
    className,
    testId
  } = _ref;
  switch (size) {
    case 'small':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleSmall, {
        className: className,
        testId: testId,
        children: avatarText
      });
    case 'medium':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleMedium, {
        className: className,
        testId: testId,
        children: avatarText
      });
    case 'large':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleLarge, {
        className: className,
        testId: testId,
        children: avatarText
      });
    case 'extraLarge':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.JumboSmall, {
        className: className,
        testId: testId,
        children: avatarText
      });
  }
};

// mapping of iconSize for each avatar size;
const iconSize = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'medium',
  extraLarge: 'large'
});
const AvatarConditionalContent = _ref2 => {
  let {
    imageSrc,
    text,
    iconName,
    size,
    iconType,
    color = 'blue',
    status,
    statusBorderColorToken,
    classNames,
    testId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'content'
    }),
    className: (0, _classify.default)(_AvatarModule.default.innerContainer, {
      [_AvatarModule.default.alignCenter]: !imageSrc
    }, classNames?.content),
    style: {
      '--background-color': AVATAR_COLOR[color]
    },
    children: [!!status && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_AvatarModule.default.statusIndicatorWrapper, _AvatarModule.default[size]),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusIndicator.StatusIndicator, {
        status: status,
        withBorder: true,
        borderColorToken: statusBorderColorToken,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'status'
        })
      })
    }), imageSrc ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: imageSrc,
      alt: "Avatar",
      className: (0, _classify.default)(_AvatarModule.default.avatar, classNames?.image),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'image'
      })
    }) : iconName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      name: iconName,
      type: iconType,
      size: iconSize[size],
      className: classNames?.icon,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'icon'
      })
    }) : text ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarTextDecorator, {
      avatarText: getAvatarText(text),
      size: size,
      className: classNames?.text,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'text'
      })
    }) : null]
  });
};
const Avatar = exports.Avatar = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    imageSrc,
    text,
    style,
    iconName,
    iconType,
    color,
    ring = false,
    status,
    statusBorderColorToken,
    testId
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.extraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.largeSize]: size === 'large',
      [_AvatarModule.default.mediumSize]: size === 'medium',
      [_AvatarModule.default.smallSize]: size === 'small'
    }, classNames?.wrapper),
    style: style,
    ref: ref,
    children: ring ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_AvatarModule.default.ring, classNames?.ring),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'ring'
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _AvatarModule.default.whiteCircle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarConditionalContent, {
          imageSrc: imageSrc,
          text: text,
          iconName: iconName,
          iconType: iconType,
          color: color,
          size: size,
          status: status,
          statusBorderColorToken: statusBorderColorToken,
          classNames: classNames,
          testId: testId
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarConditionalContent, {
      imageSrc: imageSrc,
      text: text,
      iconName: iconName,
      iconType: iconType,
      color: color,
      size: size,
      status: status,
      statusBorderColorToken: statusBorderColorToken,
      classNames: classNames,
      testId: testId
    })
  });
});
const BaseAvatar = _ref4 => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    text = '',
    style,
    color = 'blue',
    testId
  } = _ref4;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.baseExtraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.baseLargeSize]: size === 'large',
      [_AvatarModule.default.baseMediumSize]: size === 'medium',
      [_AvatarModule.default.baseSmallSize]: size === 'small'
    }, classNames?.wrapper),
    style: {
      ...style,
      background: AVATAR_COLOR[color]
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarTextDecorator, {
      avatarText: text,
      size: size,
      className: classNames?.text,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'text'
      })
    })
  });
};
exports.BaseAvatar = BaseAvatar;